import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';

import assert from 'tiny-invariant';

import { isRouteReuseKeyShared } from '@ts/shared/router/util-routes';

type RouteConfigs = Array<Route | null>;

@Injectable({
  providedIn: 'root',
})
export class RouterUrlCurrentService {
  private router = inject(Router);

  isCurrentRouteSamePage(configs: RouteConfigs): boolean {
    const currentConfigs = this.getRouteConfigs();

    if (currentConfigs.length !== configs.length) return false;
    for (let i = 0; i < currentConfigs.length; ++i) {
      if (!this.isRouteConfigSamePage(currentConfigs[i], configs[i])) {
        return false;
      }
    }
    return true;
  }

  // Routes sharing a reuse key are one page kept across them (#11677 A28), so
  // that page keeps reading their params.
  private isRouteConfigSamePage(
    routeConfig: Route | null,
    otherRouteConfig: Route | null,
  ): boolean {
    return (
      routeConfig === otherRouteConfig ||
      isRouteReuseKeyShared(routeConfig, otherRouteConfig)
    );
  }

  getRouteConfigs(): RouteConfigs {
    let currentRoute: ActivatedRoute | null = this.router.routerState.root;
    const states: ActivatedRoute[] = [];

    while (currentRoute) {
      states.push(currentRoute);
      assert(currentRoute.children.length <= 1);
      currentRoute = currentRoute.firstChild;
    }

    return states.map((state) => state.routeConfig);
  }
}
